import { createContext } from 'react';

import { IndicatorData } from '../../core/components/annotations/components/indicators/types.js';

export interface XYChartAnnotationsIndicatorsContextProps {
  alwaysVisible: IndicatorData[];
  selectable: Map<string, IndicatorData>;
}

export const XYChartAnnotationsIndicatorsContext =
  createContext<XYChartAnnotationsIndicatorsContextProps>({
    alwaysVisible: [],
    selectable: new Map(),
  });
